// src/components/AboutUs.js

import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../style/AboutUs.module.css";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.comingSoonContainer}>
        <h2 className={styles.comingSoonTitle}>{t("Coming Soon")}</h2>
        <p className={styles.comingSoonText}>
          {t("We're working on something special. Check back soon!")}
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
